import React from 'react';
import { resolveIconComponent } from './menuIcons';

/**
 * icon_class 문자열 → lucide 아이콘 엘리먼트.
 * 아이콘 목록은 lib/menuIcons.js 의 화이트리스트에서만 가져온다
 * (전체 세트를 import 하면 번들이 1.5MB 늘어난다).
 */
export const getMenuIcon = (name, size = 18) => {
  const Component = resolveIconComponent(name);
  return <Component size={size} />;
};

/**
 * 메뉴를 클릭했을 때 이동할 경로를 찾는다.
 *
 * 규칙: 자기 url_path 가 있으면 그 화면, 없으면 첫 자식의 경로.
 * (화면이 없는 그룹 메뉴는 DB 에서 url_path 를 NULL 로 두는 것을 전제로 한다 —
 *  migrations_v3/008_menu_group_paths.sql 참조)
 */
export const findFirstPath = (node) => {
  if (!node) return null;
  if (node.urlPath) return node.urlPath;

  for (const child of node.children || []) {
    const path = findFirstPath(child);
    if (path) return path;
  }

  return null;
};

/** 이 노드(또는 자손)가 현재 경로에 해당하는지 */
export const containsPath = (node, pathname) => {
  if (!node) return false;
  if (node.urlPath && (pathname === node.urlPath || pathname.startsWith(`${node.urlPath}/`))) return true;
  return (node.children || []).some((child) => containsPath(child, pathname));
};

/** 메뉴 트리를 "상위 > 하위" 형태의 검색용 목록으로 평탄화 (링크 있는 항목만) */
export const toSearchableList = (nodes, trail = [], acc = []) => {
  nodes.forEach((node) => {
    const nextTrail = [...trail, node.menuName];
    if (node.urlPath) {
      acc.push({
        menuId: node.menuId,
        menuCode: node.menuCode,
        menuName: node.menuName,
        urlPath: node.urlPath,
        iconClass: node.iconClass,
        trail: nextTrail,
        trailText: nextTrail.join(' > '),
      });
    }
    if (node.children?.length) toSearchableList(node.children, nextTrail, acc);
  });
  return acc;
};

/** 공백 무시 부분 일치 스코어링 (낮을수록 상위) */
export const scoreMatch = (item, keyword) => {
  const query = keyword.replace(/\s+/g, '').toLowerCase();
  if (!query) return 0;
  const name = item.menuName.replace(/\s+/g, '').toLowerCase();
  const trail = item.trailText.replace(/\s+/g, '').toLowerCase();
  const path = (item.urlPath || '').toLowerCase();

  if (name === query) return 0;
  if (name.startsWith(query)) return 1;
  if (name.includes(query)) return 2;
  if (trail.includes(query)) return 3;
  if (path.includes(query)) return 4;
  return -1; // 불일치
};
